import { currentPage, initNewSection } from '../common/layout';
import { banners, commentsCountUpdate, hitPageView, bannerLazyload, hybridLazyLoad, coralCommentsCountUpdate } from '../common/utils/fn';
import { getCBSWidget } from '../common/shop/cbs-widget-loader';
import initLoadMoreBtn from '../common/load-more-btn';
import { getMakeModelFilter } from '../common/make-model-filter-loader';
import '../common/msnt/msnt-lightslider.js';
import '../common/jquery-snap-scroll';
import '../common/jquery.convertmosaic';
import '../common/jquery.sticky';
import { getM1FindVehicleEu, getM1FindVehicleUs } from '../common/shop/m1-find-vehicle-widget-loader';

currentPage.pageInit = ($page, pageData, pageId) => {
  let sideBarCollection = '.sidebar';
  let currentEdition = document.querySelector('body').dataset.edtn;
  $(sideBarCollection).stickySidebar({ containerSelector: '.content-area' });
  $('#main_CR').convertMosaicToFilm();
  // fn.bigImgLazyload();
  initLoadMoreBtn();
  getMakeModelFilter().then((api) => {
    api.makeModelFilter();
  });
  getM1FindVehicleEu().then((api) => {
    api.m1FindVehicleEu();
  });
  getM1FindVehicleUs().then((api) => {
    api.m1FindVehicleUs();
  });
  commentsCountUpdate();
  if (currentEdition == 'us' || currentEdition == 'ev_us') {
    getCBSWidget().then((api) => {
      api.cbsWidget();
    });
  }
};

currentPage.pageLoadMore = ($html, $btnBox) => {
  $btnBox.replaceWith($html);
  //bigImgLazyload();
  hybridLazyLoad();
  getM1FindVehicleEu().then((api) => {
    api.m1FindVehicleEu();
  });
  getM1FindVehicleUs().then((api) => {
    api.m1FindVehicleUs();
  });
  initNewSection($html);
  $('.sidebar').stickySidebar({ containerSelector: '.content-area' });
  banners($html);
  commentsCountUpdate(true);
  hitPageView(document.location.pathname);
  bannerLazyload();
  coralCommentsCountUpdate();
};
